import React, { useCallback } from "react";

import { useStackedNavigationContext } from "fond/widgets";

import LayerUpload from "./LayerUpload";

interface LayerUploadWrapperProps {
  layerId: string;
  displayName: string;
  title: string;
  geometryType: "Point" | "LineString" | "Polygon";
  hasExistingData?: boolean;
}

const LayerUploadWrapper: React.FC<LayerUploadWrapperProps> = ({ layerId, displayName, title, geometryType, hasExistingData }) => {
  const { goBack } = useStackedNavigationContext();

  const handleComplete = useCallback(() => {
    goBack();
  }, [goBack]);

  return (
    <LayerUpload
      layerId={layerId}
      displayName={displayName}
      title={title}
      geometryType={geometryType}
      onComplete={handleComplete}
      hasExistingData={hasExistingData}
    />
  );
};

export default LayerUploadWrapper;
